import { render } from "./ReceiptShow.vue?vue&type=template&id=a5164840"
import script from "./ReceiptShow.vue?vue&type=script&lang=js"
export * from "./ReceiptShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__